<template>
  <header id="header">
    <div class="header-top">
      <slot></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  components: {},
  props: {},
  data: () => {
    return { title: undefined }
  }
}
</script>
